import { Account } from "../models/account.model";
import { Journey } from "../models/journey.model";
import { Products } from "../models/products.model";
import { User } from "../models/user.model";

export const TEST_LICENSE_GROUP: Products = {
  Connector: [
    {
      id: 115,
      code: 'E',
      name: 'Generic SMTP Server',
      subtitle: 'Send mail from your server',
      description: null,
      type: 'Connector',
      category: 'System connectors',
      enabled: true,
    },
    {
      id: 116,
      code: 'R',
      name: 'REST HTTP',
      subtitle: 'Query external services',
      description: null,
      type: 'Connector',
      category: 'System connectors',
      enabled: true,
    },
    {
      id: 117,
      code: 'RL',
      name: 'Generic Rule',
      subtitle: 'Guide the conversation',
      description: null,
      type: 'Connector',
      category: 'System connectors',
      enabled: true,
    },
    {
      id: 118,
      code: 'DT',
      name: 'Data Transfer',
      subtitle: 'Transfer data between connectors',
      description: null,
      type: 'Connector',
      category: 'System connectors',
      enabled: true,
    },
    {
      id: 119,
      code: 'Q',
      name: 'Quelix',
      subtitle: 'Advanced search tool',
      description: null,
      type: 'Connector',
      category: 'System connectors',
      enabled: true,
    },
    {
      id: 121,
      code: 'DLP',
      name: 'Data Loss Prevention',
      subtitle: 'Discover and redact sensitive data',
      description: null,
      type: 'Connector',
      category: 'Google Cloud API',
      enabled: true,
    },
    {
      id: 122,
      code: 'NL',
      name: 'Natural Language',
      subtitle: 'Sentiment and syntax analysis',
      description: null,
      type: 'Connector',
      category: 'Google Cloud API',
      enabled: true,
    },
    {
      id: 123,
      code: 'T',
      name: 'Translate',
      subtitle: 'Translate text between languages',
      description: null,
      type: 'Connector',
      category: 'Google Cloud API',
      enabled: true,
    },
  ],
  'Conversational model': [
    {
      id: 124,
      code: 'T_B',
      name: 'Booking appointments',
      subtitle: 'Collects user information and manages appointment bookings and cancellations',
      description: null,
      type: 'Conversational model',
      category: null,
      enabled: true,
    },
    {
      id: 125,
      code: 'T_S',
      name: 'Store locator',
      subtitle: 'Guide your potential customers to your stores and show the services you offer',
      description: null,
      type: 'Conversational model',
      category: null,
      enabled: true,
    },
  ],
  Module: [
    {
      id: 126,
      code: 'M_C',
      name: 'Core',
      subtitle: '',
      description: null,
      type: 'Module',
      category: null,
      enabled: true,
    },
    {
      id: 127,
      code: 'M_A',
      name: 'Advance Analytics',
      subtitle: '',
      description: null,
      type: 'Module',
      category: null,
      enabled: true,
    },
    {
      id: 128,
      code: 'M_CL',
      name: 'Clustering',
      subtitle: '',
      description: null,
      type: 'Module',
      category: null,
      enabled: true,
    },
    {
      id: 131,
      code: 'M_I',
      name: 'Intent Design',
      subtitle: '',
      description: null,
      type: 'Module',
      category: null,
      enabled: true,
    },
  ],
  Channel: [
    {
      id: 143,
      code: 'C_F',
      name: 'Facebook Messenger',
      subtitle: 'Build lasting customer relationships through conversation',
      descriptionList: null,
      description: [
        'Build lasting customer relationships through conversation. Facebook Messenger allows you to connect with billions of people in a channel they prefer, making business personal and convenient.',
        'Businesses can generate, qualify, and follow up with leads at scale through automated or live chat experiences. Messenger also helps businesses in retail, e-commerce, telcom, and more remove friction along the path to purchase, giving people confidence to move from consideration to action.',
        'Take advantage of the integration between Tellya and Messenger to provide 24-hour assistance to users of your Facebook page.',
      ],
      type: 'Channel',
      category: 'Social',
      enabled: true,
      deployed: true,
      productLink: 'https://developers.facebook.com/products/messenger/',
    },
    {
      id: 173,
      code: 'C_G',
      name: 'Google Chat',
      subtitle: 'Tap into the best of Google Workspace, smarter chat with bots',
      descriptionList: null,
      description: [
        'From direct messages to group conversations, Google Chat helps teams and businesses collaborate fluidly and efficiently from anywhere.',
        'Securely connect with anyone you work with, and take group work to the next level with shared chat, files and tasks.',
        'Easily integrate both Google and third-party apps to keep all of your notifications in one place, and use bots to automate simple tasks so you can focus on what matters.',
      ],
      type: 'Channel',
      category: 'Social',
      enabled: true,
      deployed: true,
      productLink: 'https://developers.google.com/chat/how-tos/bots-publish',
    },
    {
      id: 160,
      code: 'C_L',
      name: 'LivePerson',
      subtitle: 'Engage with consumers directly in their preferred communication channels',
      descriptionList: null,
      description: [
        'Automate consumer interactions on the most popular messaging channels without hiring an army of agents. We will help you understand the most popular consumer intents and how well you’re fulfilling them, so you can build AI-powered chatbots that work together with your human experts to generate leads, drive sales, and build loyalty.',
        'Thanks to the integration with Tellya, it is possible to connect a virtual agent, able to converse with customers and support needs. In addition, you can configure the handover to a human agent, for a more specific or dedicated support, defining topics in Tellya.',
      ],
      type: 'Channel',
      category: 'Contact center',
      enabled: true,
      deployed: true,
      productLink: 'https://www.liveperson.com/',
    },
    {
      id: 175,
      code: 'C_TE',
      name: 'Microsoft Teams',
      subtitle: 'Meet, chat, call, and collaborate in just one place.',
      descriptionList: null,
      description: [
        'Whether it’s chat, calls, or video, anyone can engage at any time, bringing everyone closer.',
        'Your docs, photos, videos, chat history, and meeting notes are always there, so it’s easier to work together.',
        'Set up your team’s space with all the apps you need so you can stay in just one place instead of jumping around.',
      ],
      type: 'Channel',
      category: 'Social',
      enabled: true,
      deployed: true,
      productLink: 'https://www.microsoft.com/it-it/microsoft-teams/group-chat-software',
    },
    {
      id: 158,
      code: 'C_T',
      name: 'Tim RCC',
      subtitle: 'Innovation at the service of Customer Care',
      descriptionList: null,
      description: [
        'TIM Ready Contact Center offers a wide suite of inbound / outbound voice and multi-channel services, aimed at Customer Service. It is a simple and flexible solution that reduces the complexity of managing IT systems.',
        "The service is provided in Cloud mode, with no burden on the Customer's IT systems. The Intelligent Virtual Assistant is also able to manage multiple users at the same time and provide immediate answers. An active 24/7 Customer Care is thus guaranteed.",
        'Thanks to the integration with Tellya, it can be associated with a ChatBOT or VoiceBOT access channel and be consulted via the web, telephone channel and messaging systems.',
      ],
      type: 'Channel',
      category: 'Contact center',
      enabled: true,
      deployed: true,
      productLink: 'https://ellysse.it/services/contatta/',
    },
    {
      id: 155,
      code: 'C_V',
      name: 'Vivocha',
      subtitle: 'Next Generation Customer Engagement Platform',
      descriptionList: null,
      description: [
        'Vivocha is a cloud-based service, tailored to businesses aiming to engage with visitors on their online sites. By using the most effective communication channels, Vivocha engages the right agent with the right visitor, at the right time.',
        'Businesses are able to seamlessly communicate with their online guests directly on their website, using any combination of video, voice, chat, and collaboration tools such as assisted browsing and form and document sharing.',
        'Thanks to the integration with Tellya, it is possible to connect a virtual agent, able to converse with customers and support needs. In addition, at any time of the conversation, you can configure the handover to a human agent, for a more specific or dedicated support.',
      ],
      type: 'Channel',
      category: 'Contact center',
      enabled: true,
      deployed: true,
      productLink: 'https://www.vivocha.com/ ',
    },
  ],
};

export const TEST_JOURNEY_GETALL: Journey[] = [
  {
    id: 232,
    name: 'Dispatcher test',
    apiKey: '3b3f6c7a5ddb3eb395679754c2ed0677',
    description: 'Journey dispatcher',
    createdBy: null,
    createdDate: null,
    lastModifiedDate: null,
    type: null,
    agent: null,
  }
];

export const TEST_GET_JOURNEY = {
  id: 3,
  name: 'journey-demo',
  status: 'DEPLOYED',
  apiKey: 'ly1XiLweu6vC9hwiKQW6',
  embedded: '',
  description: '',
  serviceAccount:
    '{\n  "type": "service_account",\n  "project_id": "tellya-stage-botgeneral",\n  "private_key_id": "67fe0d79523bb633b60553a843711908c042e5fa",\n  "private_key": "-----BEGIN PRIVATE KEY-----\\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQC249nq7TOGLctq\\n/J38tLvkjnqURrERSUHQnYWC72PJ76xFHc28d3kPs+3npk45R4X4NYxHNF7F3iYw\\nk5ZUFZWZSSh24hkjPuOrWOr6lbZ9ah9EC1xdwK3/2GO5YkrrhbjZAzeM3QjwBU7U\\n15NPW88XPVOngAwNG8hRlrqwnv6HtLN+1SUCNokBF9kn1pV01QRbKWpy/GuJwuV5\\nPFDwKP2G8qjj0AgPQHaQseCTZ7agkrEcjt4HoAQvTo750KCiFhkg525MqMvzyrlx\\nstZWsrH93hN1FukUyrEQu0Mrll8bGvSIv12uyrYwOsmIOoLa5t+G7rhZLgU68CJs\\nNdqeZtcVAgMBAAECggEAILSg4vPdr6xPUPfRaeBJLH91OMBmiEyVLjEJL+fO7M0F\\nPcvtX3tvBQmcbP1Oxkv9z2wGBLK/Evvd0PiHnMxKVyHf0Fiw/Z5QuPLa/Ipa2tUo\\nN7MfZq2fAB5qgPusoa8lZft/Ctv5LfEJDqNpdrrYjxOauty5avuxqDN/+bdJFavD\\nswJ/0qU/KZoRncMyr7CI/2tZwEU8mg8bk/dceAVgVN/Gi3wjy6vZfxxFiQZJ7QDg\\ny/BDSIywkmsrDe6RGQw1rqczc0xnICi/LI7vWLBH+GdHq0iTH1O3wvWNh7KZEfNc\\nBS90O6in8n1xNYNGzmL0RqAlqjrcZvNFHLYfcNeLEQKBgQDfSv+/A9zBf0BViq9u\\nV6JzC069MAA0FnIykb30KfVBcfd7isS1mnfLwG5oTANG8jehT1kek8FX976oLXdj\\nO+EbunM1tteVQ859MB8UXyhf2HY8mvZ6NSTQK0MR2qOjLygBXgrwvqKTKOFgGW4a\\nwA3qe6bO/q3M81qGluufKs3w5QKBgQDRrdSa0wRnIbQlEAmKJNUbMye7O76PjLQk\\nyf7NrL3PfAJOKtuOIvzhYR+jTdWkIFbW4auncJgIo81b1rzr/z8dXwIGzdDxNoLW\\npmpI02n00NxHnhnZbwVkgT6rCJEqE8VtwFrefSoNIJ/kEu48N8BrAKUSs0909Z5V\\ndZl6HaNacQKBgAlWxK2Dhtcc8F7jhwTRa3zuSyPEfy2uhqYwzEYK/zP2hUhIfIOv\\n6zS9XqDEFRsBhGwdund57Is2VGYKSMUAuyCCwtDLTebzSA6aVaJvfGvNzNwqCwb/\\ndAO024BCqbdogH7WJRT+lCQdgJeZWK6Lu8lD1K0xn6lDwFSCuWYVzzk1AoGBAJKc\\nyrlLbZuzXGRB93mp0X0IYvKvjsqPJvNGbq1f6QTogDAqFYUof8wT/mxQo1704eO0\\nvjMBLr1z08cwur8FphsicKdTSJMxe4EdsdmkQkVVuYE2UnrP/2RMXwZ2ohJa6sSY\\nKLHDsSCmvEZc2kou7ZOkSshtqtRsXj8BUMSrbqpxAoGBANdp0UBoA/fdN9ShFFoO\\n6L2nobXTWDGpCgJPFqvAjK4LN5F8eWcLVnSb12zWHm5gYyP72oGY9D9KxLvTh9Hk\\nSSiSX5BZ6mtd5IDn92KCib3/1h4NnaXcd3K0oX10KPEa2XVUpZj6InpPw6QWKGJ2\\nvpd1hclaHEWvIyHaHueEO65n\\n-----END PRIVATE KEY-----\\n",\n  "client_email": "tellya-stage-master@tellya-stage-botgeneral.iam.gserviceaccount.com",\n  "client_id": "104000027573605184014",\n  "auth_uri": "https://accounts.google.com/o/oauth2/auth",\n  "token_uri": "https://oauth2.googleapis.com/token",\n  "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",\n  "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/tellya-stage-master%40tellya-stage-botgeneral.iam.gserviceaccount.com"\n}\n',
  projectId: 'tellya-stage-botgeneral',
  createdBy: 'admin@localhost',
  createdDate: 1603308152216,
  lastModifiedDate: 1604662747483,
};

export const TEST_USER: User = {
  id: 5,
  firstName: 'TestName',
  lastName: 'TestSurname',
  email: 'test@mail.it',
  resetKey: null,
  enabled: true,
  lang: 'it',
  accountId: 1,
  verified: false,
  permissions: [
    'admin.user.view',
    'admin.user.editor',
    'admin.training.write',
    'admin.training.read',
    'admin.auditlog.view',
    'analytics.view',
    'analytics.customreport.write',
    'billing.view',
    'channel.write',
    'channel.read',
    'design.response.write',
    'design.response.read',
    'design.processflow.translate.write',
    'design.processflow.translate.read',
    'design.processflow.smtp.write',
    'design.processflow.smtp.read',
    'design.processflow.rule.write',
    'design.processflow.rule.read',
    'design.processflow.quelix.write',
    'design.processflow.quelix.read',
    'design.processflow.naturallanguage.write',
    'design.processflow.naturallanguage.read',
    'design.processflow.httprest.write',
    'design.processflow.httprest.read',
    'design.processflow.httperrorhandler.write',
    'design.processflow.httperrorhandler.read',
    'design.processflow.eventcaller.write',
    'design.processflow.eventcaller.read',
    'design.processflow.dlp.write',
    'design.processflow.dlp.read',
    'design.processflow.dispatcher.write',
    'design.processflow.dispatcher.read',
    'design.processflow.datatransfer.write',
    'design.processflow.datatransfer.read',
    'design.processflow.dataprocess.write',
    'design.processflow.dataprocess.read',
    'design.processflow.codeconnector.write',
    'design.processflow.codeconnector.read',
    'design.processflow.actionmapping.write',
    'design.processflow.actionmapping.read',
    'design.pagesettings.tags.write',
    'design.pagesettings.tags.read',
    'design.pagesettings.resource.write',
    'design.pagesettings.resource.read',
    'design.pagesettings.pagestatus.write',
    'design.pagesettings.pagestatus.read',
    'design.journey.write',
    'design.journey.read',
    'design.entity.write',
    'design.entity.read',
    'generic.journey.list',
    'healthcheck.validation.view',
    'healthcheck.regressiontest.write',
    'healthcheck.regressiontest.tester',
    'healthcheck.regressiontest.read',
    'homepage.view',
    'marketplace.write',
    'marketplace.read',
    'monitoring.status.view',
    'monitoring.logs.view',
    'training.write',
    'training.read',
    'version.view',
    'version.editor',
  ],
  roles: [
    {
      id: 1,
      accountId: 1,
      defaultRole: false,
      description: 'null',
      name: 'ADMIN',
      permissions: [],
      usedBy: 0,
      userAccounts: [],
    },
  ],
  fullName: 'TestName TestSurname',
};

export const TEST_ACCOUNTS: Account[] = [
  {
    id: 1,
    code: 'TELLYA',
    name: 'Tellya',
    customerId: 1,
    customerName: 'default',
    startDate: 1611529200000,
    endDate: 1706310000000,
    projectId: 'tellya-stage-botgeneral',
    bucketName: null,
    email: 'pietro@noovle.com',
    serviceAccount: 'account-tellya-sa',
  },
];
